import { ViewSupport48Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport48Container"
export function ViewSupport48Page() {
    return (
        <ViewSupport48Container />
    )
}